import http from "@/utils/request";

const warehouse = {
  getWarehouseList: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderWarehouseService.queryWarehouseList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default warehouse;
